import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  //api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  api_host: "https://i.fundra.com", // your managed reverse proxy domain
  ui_host: "https://eu.posthog.com",
  capture_pageview: "history_change",
  capture_exceptions: true,
  capture_dead_clicks: true,
});
